<template>
  <div class="custom-page-root">
    <template v-if="env.isApp">
      <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
        <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
          <template #left>
            <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
          </template>
        </van-nav-bar>
      </div>

      <div class="custom-page-con" :style="`margin-top:-${barHeight + 46}px`">
        <img v-if="imgUrl" class="content-img" :src="imgUrl | imgPath" />
        <div v-else class="page-404">
          <img src="@/assets/packageAssets/common/null_bg.png" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="custom-page-con">
        <img v-if="imgUrl" class="content-img" :src="imgUrl | imgPath" />
        <div v-if="!imgUrl && !isLoading" class="page-404">
          <img src="@/assets/packageAssets/common/null_bg.png" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getCustomImgPageCfg } from './apidir/api.js'

export default {
  data() {
    return {
      imgUrl: '',
      isLoading: false,
    }
  },
  methods: {
    getBaseInfo() {
      const customPageId = this.$route.params.customPageId
      const lang = this.$route.query.language || 'en'
      if (customPageId) {
        this.isLoading = true
        getCustomImgPageCfg({ route: customPageId, language: lang })
          .then((resData) => {
            if (resData) {
              this.imgUrl = resData
            }
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
          })
      }
    },
  },
  created() {
    this.getBaseInfo()
  },
}
</script>
<style lang="scss" scoped>
.custom-page-root {
  width: 100%;
  min-height: 100vh;

  .custom-nav-block {
    background-color: transparent;
  }

  .custom-page-con {
    width: 100vw;
    min-height: 100vh;
    position: relative;
    .content-img {
      width: 100%;
    }
    .page-404 {
      width: 200px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 99;

      img {
        width: 100%;
      }
    }
  }
}
</style>
